import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import b1 from "../../assets/images/blogSliderImg.png";
import b2 from "../../assets/images/blogSliderImg.png";
import b3 from "../../assets/images/blogSliderImg.png";
import { formatBlogDate, getBlogList } from "../../helper/backend-methods";
const BlogSlider = () => {
  const history = useNavigate();
  const [featuredBlogs, setFeaturedBlogs] = useState([]);
  const [loading, setLoading] = useState(false);
  const banners = [
    {
      title: "Behind the Grill: How We Make Every Bite Feel Like Home",
      desc: "Proin lobortis pharetra euismod. Integer ut justo eu quam pretium pellentesque. Sed congue dolor quis elit.",
      date: "29 August, 2025",
      status: "Community",
      img: b1,
    },
    {
      title: "All Your Favorites in One Place",
      desc: "From pantry staples to fresh produce, snacks, and more — everything you need, all in one stop.",
      date: "29 August, 2025",
      status: "Community",
      img: b2,
    },
    {
      title: "Snack Break Favorites",
      desc: "Quick bites, bold flavors, and satisfying snacks to fuel your day anytime.",
      date: "29 August, 2025",
      status: "Community",
      img: b3,
    },
  ];

  const [centerIndex, setCenterIndex] = useState(0);
  const [bp1815, setBp1815] = useState(false);
  const [bp1715, setBp1715] = useState(false);
  const [bp1615, setBp1615] = useState(false);
  const [bp1555, setBp1555] = useState(false);

  useEffect(() => {
    
    const handleResize = () => {
      const w = window.innerWidth;
      setBp1815(w <= 1815);
      setBp1715(w <= 1715);
      setBp1615(w <= 1615);
      setBp1555(w <= 1555);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setCenterIndex((prev) => (prev + 1) % banners.length);
    }, 4000);

    return () => clearInterval(interval);
  }, [banners.length]);

  const getPosition = (index) => {
    const total = banners.length;
    const diff = (index - centerIndex + total) % total;

    if (diff === 0) return "center";
    if (diff === 1) return "right";
    if (diff === total - 1) return "left";
    return "hidden";
  };

  const styles = {
    center: {
      left: "50%",
      scale: 1,
      zIndex: 30,
      opacity: 1,
    },
    left: {
      left: bp1555 ? "-73%" : bp1615 ? "-43%" : bp1715 ? "-40%" : bp1815 ? "-35%" : "-3%",
      scale: bp1715 ? 0.75 : 0.85,
      opacity: 0.6,
      zIndex: 20,
    },
    right: {
      left: bp1555 ? "173%" : bp1615 ? "143%" : bp1715 ? "140%" : bp1815 ? "135%" : "103%",
      scale: bp1715 ? 0.75 : 0.85,
      opacity: 0.6,
      zIndex: 20,
    },
    hidden: {
      opacity: 0,
      scale: 0.7,
      zIndex: 0,
    },
  };


  const getBlogs = () => {
    setLoading(true);
    getBlogList({
      Category: null,
      PageIndex: 0,
      PageSize: 3,
      SortBy: "oldest",
      IsFeaturedBlog: true
    })
      .then(({ data }) => {
        if (data.Status) {
          setFeaturedBlogs(data.Data?.Blogs || []);
          setLoading(false);
        }
      })
      .catch((e) => {
        console.error(e);
        setFeaturedBlogs([]);
      })
      .finally(() => {
        setLoading(false);
      });
  };
  

  /* 🔹 FETCH BLOGS - directly in useEffect */
  useEffect(() => {
    getBlogs();
  }, []);

  return (
    <section id="blog-banner">
      <div className="custom-carousel-container">
        <div className="custom-carousel">
          {featuredBlogs.map((banner, index) => {
            const pos = getPosition(index);
            const s = styles[pos];

            return (
              <div
                key={index}
                className={`banner-slide ${pos}`}
                style={{
                  left: s.left,
                  opacity: s.opacity,
                  zIndex: s.zIndex,
                  transform: `translateX(-50%) scale(${s.scale})`,
                  transition: "all 0.6s cubic-bezier(0.4, 0, 0.2, 1)",
                }}
                onClick={() => {setCenterIndex(index); history(`/blog/${banner.Id}`)}}
              >
                <div className="banner-image-container">
                  <img src={banner.PictureUrl} alt={banner.Title} className="banner-full-image" />
                </div>
                <div className="banner-text-overlay">
                    <div className="banner-status">
                        <span className="date">{formatBlogDate(banner.CreatedOn)}</span>
                        <li>
                            <span className="status">{banner.Category}</span>
                        </li>
                    </div>
                  <h1 className="title">{banner.Title}</h1>
                  <p className={`description ${banner.PictureUrl === b2 ? "des-gray" : "des-white"}`}>{banner.ShortDescription}</p>
                </div>
                <button className={`cta-button cta-btn-red`}>Featured</button>

                <div className="image-dark-overlay"></div>
              </div>
            );
          })}
        </div>

        {/* ===================== DOTS ===================== */}
        <div className="carousel-dots">
          {banners.map((_, i) => (
            <button key={i} className={`dot ${i === centerIndex ? "active" : ""}`} onClick={() => setCenterIndex(i)} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default BlogSlider;
